/**
 * Better Auth client for Mako web UI
 */
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  baseURL: window.location.origin,
});

// Export hooks for convenience
export const { useSession, signIn, signOut } = authClient;

// Sign in with Google
export async function signInWithGoogle() {
  await signIn.social({
    provider: "google",
    // Redirect back to the current origin after OAuth completes
    // In dev: http://localhost:5173, in prod: https://mako.example.com
    callbackURL: window.location.origin,
  });
}

// Sign out
export async function handleSignOut() {
  await signOut();
  // Reload the page to clear any cached state
  window.location.reload();
}
